import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ExportOfferAd } from 'src/app/domain/models/ExportOffer';
import { environment } from 'src/environments/environment';
import { ExportOfferUtils } from '../../util/export-offer-utils';



@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.css']
})
export class ProductCardComponent {

  @Input()
  offer: ExportOfferAd | undefined

  @Input()
  pricePerCase: number | undefined

  @Output()
  navigateTo = new EventEmitter

  constructor() {}

  navigateToDetail() {
    this.navigateTo.emit()
  }

  getExportOfferImageUrl(offer: any, index: number) {
    return ExportOfferUtils.getImageUrl(offer, offer.pictures, index)
  }
}
